export const getSiteMessage = (state) => state.siteMessage.message;
